import { Component } from '@angular/core';
import { NavParams, Events, Platform } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CoOnlineResourcesWidgetModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-online-resources-widget-modal',
  templateUrl: 'co-online-resources-widget-modal.html'
})
export class CoOnlineResourcesWidgetModalComponent {

  clientKeyword: string;
  currentPlatform: string;
  section: any;

  constructor(private navParams: NavParams, private events : Events, private timeout : TimeoutFunctionsProvider, private platform: Platform, private inAppBrowser: InAppBrowser) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.section = this.navParams.data.section;
    this.currentPlatform = this.navParams.data.currentPlatform;
    this.clientKeyword = this.navParams.data.clientKeyword;
  }

  ngOnInit() {

  }

  openUrl(url) {
    if (this.platform.is('cordova')) {
      this.inAppBrowser.create(`${url}`, "_system");
    } else {
      console.log(url);
      window.open(`${url}`, '_blank');
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/co-online-resources-widget-modal/co-online-resources-widget-modal.ts